var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-outline-info",attrs:{"type":"button"},on:{"click":_vm.open}},[_c('i',{staticClass:"fa fa-search mr-1"}),_vm._v("\n  Detalhes\n  "),(_vm.fullLabel)?_c('span',[_vm._v("do item")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }